(ns manage.feed-mapping-table.db
  (:require [common.db.table.backend :refer [map->InMemoryBackend]]
            [common.db.table.core :refer [register-table]]))

(def backend
  (map->InMemoryBackend {}))

(register-table
 {:namespace :table.feed-mapping
  :value-sub [:resource.feed-importers/fields]
  :initial-page {}
  :initial-search {}
  :initial-sort {}
  :backend backend})
